module.exports = __webpack_public_path__ + "static/presidents-message-small-thumbnails-100x100-9aec95c1c910ca723e44b60cfc4827b5.jpg";